<template>
    <div id="ag-grid-demo">
        <vx-card>
            <!-- Filter Request Code -->
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>Device Request Code</span>
                </div>
                <div class="vx-col sm:w-2/5 w-full">
                    <vs-input v-model="request_code" id="txt-search" type="text" placeholder="Device request code"
                        class="w-full" />
                </div>
            </div>
            <!-- Filter Device Type -->
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>Device Type</span>
                </div>
                <div class="vx-col sm:w-2/5 w-full">
                    <v-select autocomplete v-model="selected_type" placeholder="Select device type"
                        :options="device_type">
                    </v-select>
                </div>
            </div>
            <!-- Filter Device -->
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>Device Code</span>
                </div>
                <div class="vx-col sm:w-2/5 w-full">
                    <v-select id="cbo-merchant" inputId="txt-device" v-model="filter_device" placeholder="Select device"
                        :options="device_list">
                    </v-select>
                </div>
            </div>

            <!-- Button -->
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>&nbsp;</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-button id="btn-filter" icon-pack="feather" icon="icon-search"
                        v-on:click="fetchData(1, 20, true)" class="mr-3 mb-2 float-left">Filter</vs-button>
                    <vs-button id="btn-reset" icon-pack="feather" icon="icon-refresh-cw" color="warning"
                        v-on:click="resetFilter()" class="mr-3 mb-2 float-left">Reset</vs-button>
                </div>
            </div>
        </vx-card>

        <vx-card>
            <div class="flex flex-wrap justify-between items-center">
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * limit - (limit - 1) }} - {{ dataCount - currentPage *
                                    limit > 0 ? currentPage * limit : dataCount
                            }} of {{ dataCount }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <vs-dropdown-menu id="ddl-page-limit">
                            <vs-dropdown-item id="ddl-page-limit-1" @click="fetchData(1, 20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-2" @click="fetchData(1, 50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-3" @click="fetchData(1, 100)">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-4" @click="fetchData(1, 150)">
                                <span>150</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-5" @click="fetchData(1, totalData)">
                                <span>Show All</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-button color="success" id="btn-download-xlsx" icon-pack="feather" icon="icon-download"
                        v-on:click="exportXLSX()" class="mr-3 mb-2 float-left">Download CSV</vs-button>
                </div>
            </div>
            <ag-grid-vue :gridOptions="gridOptions" class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="dataTrx" rowSelection="multiple"
                colResizeDefault="shift" :animateRows="true" :floatingFilter="true" :pagination="true"
                :paginationPageSize="limit" :suppressPaginationPanel="true" :enableCellTextSelection="true">
            </ag-grid-vue>
            <vs-pagination :total="totalPage" :max="maxPageNumbers" v-model="currentPage" />
        </vx-card>
    </div>
</template>

<script>
import vSelect from "vue-select";
import "flatpickr/dist/flatpickr.css";
import { AgGridVue } from "ag-grid-vue";
import { url } from "@/configs/apiUrl";
import Axios from "@/global/AxiosCall";
import StatusDeviceRequestAgGridComponent from "@/components/cell-render-component/StatusDeviceRequestAgGridComponent";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import ActionTableAgGridComponent from "@/components/cell-render-component/device-setup/DetailGridComponent";
import "vue-simple-suggest/dist/styles.css";
import flatPickr from "vue-flatpickr-component";
import XLSX from "xlsx";
import VueSimpleSuggest from "vue-simple-suggest";


export default {
    name: "DeviceSetup",
    components: {
        AgGridVue,
        flatPickr,
        "v-select": vSelect,
        VueSimpleSuggest,
    },
    data() {
        return {
            filter_device: "",
            request_code: null,
            device_list: [],
            device_type: [],
            dataTrx: [],
            selected_type: null,
            chosen: "",
            selected: null,
            urlx: null,
            model: null,
            mode: "input",
            loading: false,
            searchQuery: "",
            gridOptions: {},
            maxPageNumbers: 7,
            gridApi: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true,
                filterParams: {
                    applyButton: true,
                    newRowsAction: 'keep'
                },
            },
            columnDefs: [
                {
                    headerName: "Merchant Name",
                    field: "merchants.full_name",
                    width: 300,
                    filter: true,
                    pinned: "left"
                },
                {
                    headerName: "Request Code",
                    field: "code",
                    filter: true,
                    width: 250
                },
                {
                    headerName: "Device Quantity",
                    field: "device_qty",
                    filter: true,
                    width: 200
                },
                {
                    headerName: "Expected Date",
                    field: "expected_date_f",
                    filter: true,
                    width: 200
                },
                {
                    headerName: "Device Type",
                    field: "device_type.name",
                    filter: true,
                    width: 200
                },
                {
                    headerName: "Status",
                    field: "status",
                    filter: true,
                    width: 200,
                    cellRendererFramework: StatusDeviceRequestAgGridComponent
                },
                {
                    headerName: "Request Date",
                    field: "created_at",
                    filter: true,
                    width: 300
                },
                {
                    headerName: "Actions",
                    field: "id",
                    filter: false,
                    editable: false,
                    cellRendererParams: { isConfigure: true, isDetail: true },
                    cellRendererFramework: ActionTableAgGridComponent,
                    width: 300
                }
            ],
            dataCount: 0,
            totalPage: 0,
            page: 1,
            limit: 20,
            totalData: 1,
        };
    },
    watch: {
        "$store.state.windowWidth"(val) {
            if (val <= 576) {
                this.maxPageNumbers = 4;
                this.gridOptions.columnApi.setColumnPinned("Channel", null);
            } else this.gridOptions.columnApi.setColumnPinned("Channel", "left");
        }
    },
    computed: {
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1;
            },
            set(val) {
                this.fetchData(val, this.limit);
            }
        }
    },
    methods: {
        exportXLSX() {
            let newUrl = url.svd.device_setup.list + "?page=1&limit=999999999999999";
            if (this.filter_device !== "" && this.filter_device !== null)
                newUrl += "&device_code=" + this.filter_device.code;
            if (this.selected_type !== "" && this.selected_type !== null)
                newUrl += "&device_type_id=" + this.selected_type.id;
            if (this.request_code !== "" && this.request_code !== null)
                newUrl += "&request_code=" + this.request_code;

            Axios.Get(newUrl)
                .then((res) => {
                    this.jsonToCsv = [];
                    if (res.data.length !== 0) {
                        for (let data of res.data.data) {
                            this.jsonToCsv.push({
                                "Merchant_Name": data.merchants.full_name,
                                "Request_Code": data.code,
                                "Device_Quantity": data.device_qty,
                                "Expected_Date": data.expected_date_f,
                                "Device_Type": data.device_type.name,
                                "Status": data.status,
                                "Request_Date": data.created_at
                            });
                        }
                    }
                    let exportData = XLSX.utils.json_to_sheet(this.jsonToCsv);
                    let exportDataCSV = XLSX.utils.sheet_to_csv(exportData);

                    const url = window.URL.createObjectURL(new Blob([exportDataCSV]));
                    const link = document.createElement("a");
                    link.href = url;
                    let file_name = "device-request-setup-" + Date.now() + ".csv";
                    link.setAttribute("download", file_name);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch(() => {
                    console.log("failed export data");
                });
        },
        openLoading() {
            this.$vs.loading({
                type: "default",
            })
        },
        fetchData(page, limit) {
            this.openLoading()
            let newPage = page;

            if (this.dataCount != 0) {
                let totalPages = Math.ceil(this.dataCount / limit);
                if (page > totalPages) {
                    newPage = totalPages;
                }
            }

            newPage
            let newUrl = url.svd.device_setup.list + "?page=" + page + "&limit=" + limit;
            if (this.filter_device !== "" && this.filter_device !== null)
                newUrl += "&device_code=" + this.filter_device.code;
            if (this.selected_type !== "" && this.selected_type !== null)
                newUrl += "&device_type_id=" + this.selected_type.id;
            if (this.request_code !== "" && this.request_code !== null)
                newUrl += "&request_code=" + this.request_code;

            Axios.Get(newUrl).then(resp => {
                this.$vs.loading.close()
                this.dataTrx = [];
                if (resp.data.data.length != 0) {
                    this.totalData = parseInt(resp.data.total)
                    let no = ((page - 1) * limit) + 1;
                    for (let data of resp.data.data) {
                        data.no = no;
                        this.dataTrx.push(data);
                        no++;
                    }

                    this.dataCount = resp.data.total;
                    this.page = page;
                    if (limit >= this.dataCount) {
                        this.limit = this.dataTrx.length;
                    } else {
                        this.limit = limit;
                    }

                    this.gridApi.paginationSetPageSize(this.limit);
                    this.totalPage = resp.data.lastPage;
                }
            }).catch(e => {
                this.$vs.loading.close()
                console.log(e);
            })
        },
        detailRecord(value) {
            this.$router.push({
                name: "deviceSetupDetail",
                query: {
                    id: value
                }
            });
        }
    },
    mounted() {
        let merchant = JSON.parse(localStorage.getItem("userInfo")).merchant;

        let merchantidquery = "";

        let merchantid =
            merchant.id !== undefined
                ? merchant.id
                : merchant.parent_id !== undefined
                    ? merchant.parent_id
                    : "";

        if (merchantid !== "") merchantidquery = "?merchant_id=" + merchantid;

        Axios.Get(url.svd.device.combo + merchantidquery).then((resp) => {
            this.device_list = [];
            if (typeof resp.data !== "undefined")
                for (let data of resp.data) {
                    data.label = data.code;
                    this.device_list.push(data);
                }
        });

        Axios.Get(url.svd.device_type.selection).then((resp) => {
            if (resp.code == 200) {
                for (let data of resp.data) {
                    data.label = data.name;
                    delete data.name;
                    this.device_type.push(data);
                }
            } else {
                this.warning("Get device type", "Fail get device type");
            }
        });

        this.gridApi = this.gridOptions.api;
        this.gridOptions.getRowStyle = function (params) {
            if (params.node.rowIndex % 2 === 0) {
                return { background: "#f9f9f9" };
            }
        };

        if (this.status) {
            this.$vs.notify({
                title: "Device Asssignment",
                text: "Device assignment success",
                color: "success",
                position: "top-right"
            });
        }
        this.gridApi = this.gridOptions.api;
        this.gridOptions.getRowStyle = function (params) {
            if (params.node.rowIndex % 2 === 0) {
                return { background: '#f9f9f9' }
            }
        }
        this.gridOptions.rowHeight = 42;

        this.$root.$on("detail-from-ActionTableAgGridComponent", data => {
            this.detailRecord(data);
        });

        this.$root.$on("configure-from-ActionTableAgGridComponent", data => {
            this.$router.push({
                name: "deviceSetupConfiguration",
                query: { id: data }
            });
        });
    }
}
</script>

<style>

</style>